import styled from 'styled-components';
import colors from '../../../assets/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
`;

export const Header = styled.header`
  background-color: #FFFFFF;
  padding: 15px;
  border-bottom: 1px solid #EAEAEA;
`;

export const Logo = styled.img`
  cursor: pointer;
  width: 60px;
  height: 60px;
`;

export const Content = styled.div`
  max-width: 480px;
  width: 100%;

  h1 {
    font-size: 22px;
    color: ${colors.primary};
    padding-bottom: 5px;
  }

  .subtitle {
    margin: 0;
    padding: 0;
    font-size: 14px;
    padding-bottom: 30px;
  }
`;

export const Button = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 14px;
  margin-top: 10px;
  background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
  border: none;
  border-radius: 100px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.white};
  font-family: 'Open Sans', sans-serif;
  outline: none;

  :hover { opacity: .9 }
`;
